/* ==========================================================================
   MOBRIO — Welcome Discount
   JavaScript vanilla. Sin dependencias externas.
   Máquina de estados, persistencia, form AJAX (customer), badge, permalink.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '.mobrio-welcome';
  var LS_KEY = 'mobrioWelcome:v1:persistent'; // por visitante
  var SS_KEY = 'mobrioWelcome:v1:session';    // por sesión

  // Estados lógicos del panel del modal
  var PANEL = { WELCOME: 'welcome', EMAIL: 'email', SUCCESS: 'success' };

  /* -------- helpers de storage tolerantes a modo privado -------- */
  function readJSON(store, key) {
    try { return JSON.parse(store.getItem(key) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function writeJSON(store, key, obj) {
    try { store.setItem(key, JSON.stringify(obj)); } catch (e) {}
  }
  function getPersistent() { return readJSON(window.localStorage, LS_KEY); }
  function setPersistent(patch) {
    var s = getPersistent();
    for (var k in patch) if (patch.hasOwnProperty(k)) s[k] = patch[k];
    writeJSON(window.localStorage, LS_KEY, s);
  }
  function getSession() { return readJSON(window.sessionStorage, SS_KEY); }
  function setSession(patch) {
    var s = getSession();
    for (var k in patch) if (patch.hasOwnProperty(k)) s[k] = patch[k];
    writeJSON(window.sessionStorage, SS_KEY, s);
  }

  function isEmail(v) {
    // Validación razonable, no estricta RFC.
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
  }

  /* ======================================================================
     Instancia del componente
     ====================================================================== */
  function MobrioWelcome(root) {
    this.root = root;
    this.opts = this._readOpts(root);

    // Nodos
    this.overlay   = root.querySelector('.mwd-overlay');
    this.modal     = root.querySelector('.mwd-modal');
    this.badge     = root.querySelector('.mwd-badge');
    this.panels    = {};
    this.panels[PANEL.WELCOME] = root.querySelector('[data-mwd-panel="welcome"]');
    this.panels[PANEL.EMAIL]   = root.querySelector('[data-mwd-panel="email"]');
    this.panels[PANEL.SUCCESS] = root.querySelector('[data-mwd-panel="success"]');
    this.form      = root.querySelector('.mwd-form');
    this.input     = root.querySelector('[data-mwd-email]');
    this.errorEl   = root.querySelector('[data-mwd-error]');
    this.submitBtn = root.querySelector('[data-mwd-submit]');

    // Timers/estado interno
    this.openDelayTimer = null;
    this.badgeTimer = null;
    this.currentPanel = PANEL.WELCOME;
    this.lastFocused = null;
    this.destroyed = false;
    this._bound = {};

    this._init();
  }

  MobrioWelcome.prototype._readOpts = function (root) {
    var d = root.dataset;
    return {
      enabled: d.enabled === 'true',
      delay: Math.max(0, parseInt(d.delay, 10) || 20) * 1000,
      badgeSeconds: Math.max(3, parseInt(d.badgeSeconds, 10) || 30) * 1000,
      badgeEnabled: d.badgeEnabled === 'true',
      code: (d.code || '').trim(),
      klaviyoKey: (d.klaviyoKey || '').trim(),
      klaviyoList: (d.klaviyoList || '').trim(),
      designMode: d.designMode === 'true'
    };
  };

  MobrioWelcome.prototype._init = function () {
    if (!this.overlay || !this.modal) return;

    // --- Design mode: en el editor de temas, mostrar de inmediato y NO persistir ---
    if (this.opts.designMode) {
      this._bindEvents();
      this._showPanel(PANEL.WELCOME);
      this.openModal(false);
      return;
    }

    if (!this.opts.enabled) return;

    var persistent = getPersistent();
    // Ya obtuvo el descuento: no molestar nunca más.
    if (persistent.completed) return;

    this._bindEvents();

    var session = getSession();

    // Si en esta sesión el badge ya expiró, no reabrir nada automáticamente.
    if (session.badgeExpired) return;

    // Si hay un estado en curso guardado en la sesión (cerró el modal antes),
    // mostrar directamente el badge para poder recuperarlo.
    if (session.pendingPanel) {
      this.currentPanel = session.pendingPanel;
      this._showBadge();
      return;
    }

    // Rechazó en una visita anterior (persistente): no auto-abrir el popup.
    // Tampoco perseguir con badge automático en visitas nuevas.
    if (persistent.declined) return;

    // Primer contacto en esta sesión: si el welcome ya se mostró en esta sesión,
    // no volver a lanzar el timer al cambiar de página.
    if (session.welcomeShown) {
      // Nada que hacer automáticamente; el usuario ya lo vio esta sesión.
      return;
    }

    // Programar apertura tras el delay.
    var self = this;
    this.openDelayTimer = window.setTimeout(function () {
      if (self.destroyed) return;
      self._showPanel(PANEL.WELCOME);
      self.openModal(true);
      setSession({ welcomeShown: true });
    }, this.opts.delay);
  };

  /* ---------------------- Eventos ---------------------- */
  MobrioWelcome.prototype._bindEvents = function () {
    var self = this;

    // Cerrar (X)
    this.root.querySelectorAll('[data-mwd-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeModal('close'); });
    });

    // Clic en overlay (fuera del modal)
    this.overlay.addEventListener('mousedown', function (e) {
      if (e.target === self.overlay) self.closeModal('close');
    });

    // Sí -> email
    var yesBtn = this.root.querySelector('[data-mwd-yes]');
    if (yesBtn) yesBtn.addEventListener('click', function () { self._showPanel(PANEL.EMAIL); self._focusInput(); });

    // No, gracias -> declinar
    var noBtn = this.root.querySelector('[data-mwd-no]');
    if (noBtn) noBtn.addEventListener('click', function () { self.closeModal('decline'); });

    // Seguir comprando -> completar
    var contBtn = this.root.querySelector('[data-mwd-continue]');
    if (contBtn) contBtn.addEventListener('click', function () { self._complete(); });

    // Envío: el contenedor es un div, no un form. Botón por click + Enter.
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', function () { self._submit(); });
    }
    if (this.input) {
      this.input.addEventListener('input', function () { self._clearError(); });
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self._submit(); }
      });
    }

    // Badge
    if (this.badge) {
      this.badge.addEventListener('click', function () { self._onBadgeClick(); });
    }

    // Escape
    this._bound.keydown = function (e) {
      if (e.key === 'Escape' && self.overlay.classList.contains('is-open')) {
        self.closeModal('close');
      } else if (e.key === 'Tab' && self.overlay.classList.contains('is-open')) {
        self._trapFocus(e);
      }
    };
    document.addEventListener('keydown', this._bound.keydown);
  };

  /* ---------------------- Panels / transiciones ---------------------- */
  MobrioWelcome.prototype._showPanel = function (name) {
    this.currentPanel = name;
    for (var key in this.panels) {
      if (!this.panels[key]) continue;
      this.panels[key].classList.toggle('is-active', key === name);
    }
    // Persistir el panel en curso (welcome/email) por si cierra.
    if (!this.opts.designMode && (name === PANEL.WELCOME || name === PANEL.EMAIL)) {
      setSession({ pendingPanel: name });
    }
  };

  /* ---------------------- Abrir / cerrar modal ---------------------- */
  MobrioWelcome.prototype.openModal = function (lockScroll) {
    this.lastFocused = document.activeElement;
    this.overlay.classList.add('is-open');
    this.overlay.setAttribute('aria-hidden', 'false');
    if (lockScroll !== false) this._lockScroll(true);
    this._hideBadge();
    var self = this;
    window.requestAnimationFrame(function () { self._focusFirst(); });
  };

  MobrioWelcome.prototype.closeModal = function (reason) {
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this._lockScroll(false);
    if (this.lastFocused && this.lastFocused.focus) {
      try { this.lastFocused.focus(); } catch (e) {}
    }

    if (this.opts.designMode) return;

    if (reason === 'decline') {
      setPersistent({ declined: true });
      // Se conserva pendingPanel = welcome para poder recuperar vía badge.
      setSession({ pendingPanel: PANEL.WELCOME });
    }
    // reason 'close' conserva el pendingPanel actual (welcome o email).

    this._showBadge();
  };

  /* ---------------------- Badge ---------------------- */
  MobrioWelcome.prototype._showBadge = function () {
    if (!this.opts.badgeEnabled || !this.badge) return;
    var session = getSession();
    if (session.badgeExpired) return;

    var self = this;
    this.badge.classList.add('is-visible');
    this.badge.setAttribute('aria-hidden', 'false');

    window.clearTimeout(this.badgeTimer);
    this.badgeTimer = window.setTimeout(function () {
      self._hideBadge();
      setSession({ badgeExpired: true });
    }, this.opts.badgeSeconds);
  };

  MobrioWelcome.prototype._hideBadge = function () {
    if (!this.badge) return;
    window.clearTimeout(this.badgeTimer);
    this.badge.classList.remove('is-visible');
    this.badge.setAttribute('aria-hidden', 'true');
  };

  MobrioWelcome.prototype._onBadgeClick = function () {
    // Reabrir en el último estado lógico válido (welcome o email).
    var panel = this.currentPanel === PANEL.EMAIL ? PANEL.EMAIL : PANEL.WELCOME;
    this._showPanel(panel);
    this.openModal(true);
    if (panel === PANEL.EMAIL) this._focusInput();
  };

  /* ---------------------- Formulario ---------------------- */
  MobrioWelcome.prototype._focusInput = function () {
    var self = this;
    window.setTimeout(function () { if (self.input) self.input.focus(); }, 60);
  };

  MobrioWelcome.prototype._clearError = function () {
    if (this.errorEl) { this.errorEl.textContent = ''; this.errorEl.classList.remove('is-visible'); }
    if (this.input) this.input.classList.remove('is-invalid');
  };

  MobrioWelcome.prototype._showError = function (msg) {
    if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.classList.add('is-visible'); }
    if (this.input) this.input.classList.add('is-invalid');
  };

  MobrioWelcome.prototype._setLoading = function (on) {
    if (!this.submitBtn) return;
    this.submitBtn.classList.toggle('is-loading', on);
    this.submitBtn.disabled = on;
  };

  MobrioWelcome.prototype._submit = function () {
    var email = this.input ? this.input.value.trim() : '';
    this._clearError();
    if (!email) { this._showError(this.root.dataset.msgRequired || 'Introduce tu email.'); return; }
    if (!isEmail(email)) { this._showError(this.root.dataset.msgInvalid || 'Introduce un email válido.'); return; }

    var self = this;
    this._setLoading(true);

    // Suscripción a Klaviyo (Client API v2024). Mismo método que el footer de
    // Mobrio: no pasa por Shopify, así se evita el captcha. Éxito = 202 Accepted.
    var key = (this.opts.klaviyoKey || '').trim();
    var list = (this.opts.klaviyoList || '').trim();

    if (!key || !list) {
      this._setLoading(false);
      this._showError('Configura la clave y la lista de Klaviyo en el editor del tema.');
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (res.status === 202 || res.ok) return true;
      throw new Error('bad_status_' + res.status);
    })
    .then(function () {
      self._onSuccess();
    })
    .catch(function () {
      self._setLoading(false);
      self._showError(self.root.dataset.msgError || 'No hemos podido completar el registro. Inténtalo de nuevo.');
    });
  };

  MobrioWelcome.prototype._onSuccess = function () {
    this._setLoading(false);
    setPersistent({ completed: true, emailReceived: true });
    setSession({ pendingPanel: null });
    this._activateDiscount();     // activa el código en la sesión (permalink)
    this._showPanel(PANEL.SUCCESS);
    var self = this;
    window.requestAnimationFrame(function () { self._focusFirst(); });
  };

  /* ----------------------------------------------------------------------
     Activación del descuento: método OFICIAL de Shopify.
     El permalink /discount/CODIGO guarda el código en la sesión del cliente
     y Shopify lo aplica automáticamente en el checkout.
     Usamos una petición en segundo plano (no navegamos ni sacamos al usuario).
     Si el navegador bloquea la petición, el código sigue disponible y el copy
     dice "listo para tu compra" (no afirmamos "aplicado al carrito").
     ---------------------------------------------------------------------- */
  MobrioWelcome.prototype._activateDiscount = function () {
    if (!this.opts.code) return;
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(this.opts.code)
      : '/discount/' + encodeURIComponent(this.opts.code);
    try {
      // no-cors: solo necesitamos que Shopify registre el código en la sesión.
      fetch(url, { method: 'GET', credentials: 'same-origin', mode: 'no-cors', keepalive: true });
    } catch (e) {}
  };

  MobrioWelcome.prototype._complete = function () {
    this.closeModalSilent();
    setPersistent({ completed: true });
    setSession({ pendingPanel: null, badgeExpired: true });
    this._hideBadge();
  };

  MobrioWelcome.prototype.closeModalSilent = function () {
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this._lockScroll(false);
    if (this.lastFocused && this.lastFocused.focus) { try { this.lastFocused.focus(); } catch (e) {} }
  };

  /* ---------------------- Scroll lock (iOS-safe) ---------------------- */
  MobrioWelcome.prototype._lockScroll = function (on) {
    var body = document.body;
    if (on) {
      this._scrollY = window.scrollY || window.pageYOffset || 0;
      body.style.position = 'fixed';
      body.style.top = '-' + this._scrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    } else {
      var y = this._scrollY || 0;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, y);
    }
  };

  /* ---------------------- Focus management ---------------------- */
  MobrioWelcome.prototype._focusables = function () {
    return Array.prototype.slice.call(
      this.modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) { return el.offsetParent !== null; });
  };
  MobrioWelcome.prototype._focusFirst = function () {
    var f = this._focusables();
    var closeBtn = this.modal.querySelector('[data-mwd-close]');
    (f[0] || closeBtn || this.modal).focus && (f[0] || closeBtn || this.modal).focus();
  };
  MobrioWelcome.prototype._trapFocus = function (e) {
    var f = this._focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---------------------- Destroy (section:unload) ---------------------- */
  MobrioWelcome.prototype.destroy = function () {
    this.destroyed = true;
    window.clearTimeout(this.openDelayTimer);
    window.clearTimeout(this.badgeTimer);
    if (this._bound.keydown) document.removeEventListener('keydown', this._bound.keydown);
    this._lockScroll(false);
  };

  /* ======================================================================
     Boot + integración con Shopify section events (evita duplicados)
     ====================================================================== */
  var instances = new WeakMap();

  function mount(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new MobrioWelcome(root));
  }
  function unmount(root) {
    var inst = instances.get(root);
    if (inst) { inst.destroy(); instances.delete(root); }
  }
  function boot() {
    document.querySelectorAll(SELECTOR).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: montar/desmontar limpiamente al recargar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SELECTOR) ||
               (e.target.matches && e.target.matches(SELECTOR) ? e.target : null);
    if (root) { unmount(root); mount(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector(SELECTOR) ||
               (e.target.matches && e.target.matches(SELECTOR) ? e.target : null);
    if (root) unmount(root);
  });
})();